import { render } from "./ContentViewLayout.vue?vue&type=template&id=eefb4de2&scoped=true"
import script from "./ContentViewLayout.vue?vue&type=script&lang=js"
export * from "./ContentViewLayout.vue?vue&type=script&lang=js"

import "./ContentViewLayout.vue?vue&type=style&index=0&id=eefb4de2&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefb4de2"]])

export default __exports__